import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=2fb67be7&"
import script from "./TextAreaField.vue?vue&type=script&lang=ts&"
export * from "./TextAreaField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports